import React from 'react';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import { useUpdateEffect } from 'react-use';
import { DataTable } from 'app/components/Charts/table';
import { useStoreActions, useStoreState } from 'app/state/store/hooks';
import {
  OrganisationsDataTableColumns,
  OrganisationsDataTableOptions,
} from 'app/components/Charts/table/data';
import { MUIDataTableOptions } from 'mui-datatables';
import { useRecoilValue } from 'recoil';
import { transactionTypeAtom } from 'app/state/recoil/atoms';

interface OrganisationsTableModuleProps {
  tableOptions?: MUIDataTableOptions;
}
export function OrganisationsTableModule(props: OrganisationsTableModuleProps) {
  const action = useStoreActions((actions) => actions.organisations.fetch);
  const actionData = useStoreState((actions) => actions.organisations.data);
  const transactionType = useRecoilValue(transactionTypeAtom);

  const tableData = get(actionData, 'data', []);
  const searchTerm = useStoreState((state) => state.syncSearch.value);
  const tableOptions = props.tableOptions
    ? props.tableOptions
    : OrganisationsDataTableOptions;

  function callAction(q?: string) {
    action({
      values: {
        filters: q && q.length > 0 ? q : {},
        transactionTypeCode: transactionType.code,
      },
    });
  }

  React.useEffect(() => {
    if (tableData.length === 0) {
      callAction(searchTerm);
    }
  }, [transactionType]);

  useUpdateEffect(() => {
    if (searchTerm && searchTerm.length > 3) {
      callAction(searchTerm);
    }
  }, [searchTerm, transactionType]);

  return (
    <DataTable
      data={tableData}
      columns={OrganisationsDataTableColumns}
      options={{
        ...tableOptions,
        sortOrder: {
          name: transactionType.name,
          direction: 'desc',
        },
        customSort: (data: any[], colIndex: number, order: string) => {
          if (colIndex === 1) {
            return orderBy(
              data,
              (item: any) => item.data[colIndex][1],
              order === 'asc' ? 'asc' : 'desc'
            );
          }
          return orderBy(
            data,
            (item: any) => item.data[colIndex],
            order === 'asc' ? 'asc' : 'desc'
          );
        },
      }}
      title={`AIDA has found ${new Intl.NumberFormat('nl-NL').format(
        tableData.length
      )} organisations for you`}
    />
  );
}
